import { API_BASE_URL } from './api-config.js';

/**
 * Thin wrapper around fetch that:
 * - Prepends API_BASE_URL
 * - Sends credentials (session cookie)
 * - Throws on non-2xx so TanStack Query treats it as an error
 *
 * @param {string} path  - e.g. '/products' or '/customers/42'
 * @param {RequestInit} [options]
 * @returns {Promise<any>} parsed JSON body
 */
export async function apiFetch(path, options = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });
  } catch (err) {
    const isNetworkError = err.name === 'TypeError' || /fetch|load failed|network/i.test(err.message || '');
    if (isNetworkError) {
      const networkError = new Error("No se pudo establecer conexión con el servidor. Por favor, verificá tu conexión a internet o intentalo de nuevo.");
      networkError.name = "NetworkError";
      networkError.originalError = err;
      throw networkError;
    }
    throw err;
  }

  if (!response.ok) {
    let message = `Error ${response.status}: ${response.statusText}`;
    try {
      const errorData = await response.json();
      message = errorData.summary || errorData.message || JSON.stringify(errorData);
    } catch {
      const text = await response.text().catch(() => '');
      if (text) message = text;
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  // 204 No Content — return null instead of trying to parse
  if (response.status === 204) return null;

  return response.json();
}
